import React, { useEffect, useState, useRef } from 'react';
import { track } from '../../utils/analytics';
import api from '../../utils/api';
import ProductCard from '../../components/ProductCard';

const CHAT_IMGS = [
  'https://res.cloudinary.com/drezxp44k/image/upload/v1777172626/chat_xaztmf.png',
  'https://res.cloudinary.com/drezxp44k/image/upload/v1777172626/chat2_ecrz02.png',
];

export default function Tienda() {
  const [productos, setProductos]     = useState([]);
  const [categorias, setCategorias]   = useState([]);
  const [catActiva, setCatActiva]     = useState('');
  const [buscar, setBuscar]           = useState('');
  const [chatOpen, setChatOpen]       = useState(false);
  const [chatImg, setChatImg]         = useState(0);
  const [msgs, setMsgs]               = useState([{ rol:'bot', texto:'¡Hola! Soy el asistente de Wawita. ¿En qué te puedo ayudar hoy?' }]);
  const [msgInput, setMsgInput]       = useState('');
  const [chatLoading, setChatLoading] = useState(false);
  const chatRef = useRef(null);

  useEffect(() => {
    api.get('/productos').then(r => setProductos(r.data)).catch(()=>{});
    api.get('/productos/categorias/lista').then(r => setCategorias(r.data)).catch(()=>{});
    const p = new URLSearchParams(window.location.search);
    if (p.get('cat')) setCatActiva(p.get('cat'));
    if (p.get('q'))   setBuscar(p.get('q'));
    // Alterna imagen cada 3 segundos
    const t = setInterval(() => setChatImg(i => (i + 1) % 2), 3000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (chatRef.current) chatRef.current.scrollTop = chatRef.current.scrollHeight;
  }, [msgs]);

  const filtrados = productos.filter(p => {
    const matchCat = !catActiva || p.categoria_id === catActiva;
    const matchBus = !buscar || p.nombre.toLowerCase().includes(buscar.toLowerCase()) || (p.descripcion_corta||'').toLowerCase().includes(buscar.toLowerCase());
    return matchCat && matchBus;
  });

  const enviarChat = async () => {
    const m = msgInput.trim();
    if (!m) return;
    setMsgInput('');
    const historial = msgs.map(x => ({ role: x.rol==='bot'?'assistant':'user', content: x.texto }));
    setMsgs(prev => [...prev, { rol:'user', texto:m }]);
    setChatLoading(true);
    try {
      const r = await api.post('/ia/chat', { mensaje:m, historial });
      setMsgs(prev => [...prev, { rol:'bot', texto:r.data.respuesta }]);
    } catch {
      setMsgs(prev => [...prev, { rol:'bot', texto:'Hubo un error. ¡Escríbenos por WhatsApp!' }]);
    } finally { setChatLoading(false); }
  };

  const QUICK = ['¿Qué ingredientes tienen?','¿Envíos a Colombia?','¿Qué es el refill?','¿Desde qué edad el desodorante?'];

  const s = {
    wrap:    { maxWidth:1280, margin:'0 auto', padding:'40px 24px 80px' },
    header:  { display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:28, flexWrap:'wrap', gap:12 },
    titulo:  { fontFamily:'var(--font-display)', fontSize:'clamp(22px, 4vw, 32px)', color:'#1C3A1E', fontWeight:400, margin:0, letterSpacing:'-0.3px' },
    count:   { fontSize:15, fontWeight:400, color:'var(--ink-faint)', marginLeft:10 },
    filtros: { display:'flex', gap:8, flexWrap:'wrap', alignItems:'center' },
    btnCat: (a) => ({
      padding:'9px 20px', borderRadius:'var(--r-full)', border:'none', cursor:'pointer',
      fontFamily:'var(--font-body)', fontWeight:600, fontSize:13,
      background: a ? '#1C3A1E' : 'rgba(255,255,255,0.55)',
      color:      a ? '#9FBE6A' : '#1C3A1E',
      transition:'var(--transition)',
      boxShadow:  a ? '0 2px 0 rgba(0,0,0,0.2)' : 'none',
    }),
    empty:    { textAlign:'center', padding:'80px 0', color:'var(--ink-faint)' },
    emptyTxt: { fontFamily:'var(--font-display)', fontSize:24, color:'var(--forest)', marginBottom:8 },
    emptyBtn: { marginTop:12, padding:'11px 28px', background:'#9FBE6A', color:'#1C3A1E', border:'none', borderRadius:'var(--r-md)', fontFamily:'var(--font-body)', fontWeight:700, cursor:'pointer', fontSize:14 },
  };

  return (
    <div>
      <div id="productos" style={s.wrap}>
        <div style={s.header}>
          <h2 style={s.titulo}>
            {catActiva ? (categorias.find(c=>c.id===catActiva)?.nombre || 'Productos') : 'Todos los productos'}
            <span style={s.count}>({filtrados.length})</span>
          </h2>
          <div style={s.filtros}>
            <button onClick={() => setCatActiva('')} style={s.btnCat(!catActiva)}>Todos</button>
            {categorias.map(c => (
              <button key={c.id} onClick={() => setCatActiva(c.id)} style={s.btnCat(catActiva===c.id)}>
                {c.nombre}
              </button>
            ))}
          </div>
        </div>

        {filtrados.length > 0 ? (
          <>
            {/* Productos normales — sin combos */}
            {filtrados.filter(p => p.categoria_id !== 'cat-d5331384').length > 0 && (
              <div className="products-grid">
                {filtrados.filter(p => p.categoria_id !== 'cat-d5331384').map(p => <ProductCard key={p.id} product={p} />)}
              </div>
            )}

            {/* Combos al final */}
            {!catActiva && filtrados.filter(p => p.categoria_id === 'cat-d5331384').length > 0 && (
              <div style={{ marginTop:56 }}>
                <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:28 }}>
                  <div style={{ flex:1, height:1, background:'rgba(28,58,30,0.1)' }} />
                  <div style={{ textAlign:'center' }}>
                    <div style={{ fontSize:28, marginBottom:4 }}>🎁</div>
                    <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(22px,4vw,30px)', color:'var(--forest)', margin:0 }}>Combos especiales</h2>
                    <p style={{ fontSize:15, color:'#1C3A1E', marginTop:4, fontWeight:600, opacity:0.8 }}>Productos seleccionados al mejor precio</p>
                  </div>
                  <div style={{ flex:1, height:1, background:'rgba(28,58,30,0.1)' }} />
                </div>
                <div className="products-grid">
                  {filtrados.filter(p => p.categoria_id === 'cat-d5331384').map(p => <ProductCard key={p.id} product={p} />)}
                </div>
              </div>
            )}

            {/* Si el filtro activo es combos */}
            {catActiva === 'cat-d5331384' && (
              <div className="products-grid">
                {filtrados.map(p => <ProductCard key={p.id} product={p} />)}
              </div>
            )}
          </>
        ) : (
          <div style={s.empty}>
            <div style={{ fontSize:52, marginBottom:16 }}>🌿</div>
            <div style={s.emptyTxt}>No encontramos productos</div>
            <button onClick={() => { setBuscar(''); setCatActiva(''); }} style={s.emptyBtn}>Ver todos</button>
          </div>
        )}
      </div>

      {/* Chat IA */}
      {chatOpen && (
        <div style={{ position:'fixed', bottom:28, right:28, width:360, background:'#FDFBF7', borderRadius:20, boxShadow:'0 12px 48px rgba(0,0,0,0.14)', zIndex:200, display:'flex', flexDirection:'column', maxHeight:520, overflow:'hidden', border:'1px solid rgba(159,190,106,0.2)' }}>
          {/* Header */}
          <div style={{ background:'#9FBE6A', padding:'12px 16px', display:'flex', alignItems:'center', gap:12 }}>
            <img src={CHAT_IMGS[chatImg]} alt="Asistente Wawita"
              style={{ width:52, height:52, borderRadius:'50%', objectFit:'cover', border:'2px solid #9FBE6A', flexShrink:0, transition:'opacity 0.4s' }} />
            <div style={{ flex:1 }}>
              <div style={{ fontFamily:'var(--font-display)', color:'#1C3A1E', fontSize:16, fontWeight:400 }}>Asistente Wawita</div>
              <div style={{ fontSize:11, color:'rgba(28,58,30,0.6)', fontFamily:'var(--font-body)' }}>En línea</div>
            </div>
            <button onClick={() => setChatOpen(false)} style={{ background:'rgba(255,255,255,0.1)', border:'none', color:'#1C3A1E', fontSize:16, cursor:'pointer', width:30, height:30, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'var(--font-body)', flexShrink:0 }}>✕</button>
          </div>

          {/* Mensajes */}
          <div ref={chatRef} style={{ flex:1, overflowY:'auto', padding:16, display:'flex', flexDirection:'column', gap:12 }}>
            {msgs.map((m, i) => (
              <div key={i} style={{ display:'flex', flexDirection:m.rol==='user'?'row-reverse':'row', gap:8, alignItems:'flex-end' }}>
                {m.rol==='bot' && (
                  <img src={CHAT_IMGS[chatImg]} alt="bot"
                    style={{ width:28, height:28, borderRadius:'50%', objectFit:'cover', flexShrink:0 }} />
                )}
                <div style={{ maxWidth:'82%', padding:'10px 14px', borderRadius:14, fontSize:14, lineHeight:1.6, fontFamily:'var(--font-body)', background:m.rol==='user'?'#9FBE6A':'rgba(28,58,30,0.08)', color:m.rol==='user'?'#1C3A1E':'var(--ink)' }}>
                  {m.texto}
                </div>
              </div>
            ))}
            {chatLoading && <div style={{ fontSize:13, color:'var(--ink-faint)', padding:'0 8px', fontFamily:'var(--font-body)' }}>Escribiendo...</div>}
          </div>

          {/* Sugerencias */}
          {msgs.length <= 1 && (
            <div style={{ padding:'0 12px 8px', display:'flex', flexWrap:'wrap', gap:6 }}>
              {QUICK.map(q => (
                <button key={q} onClick={() => setMsgInput(q)} style={{ fontSize:12, padding:'6px 12px', borderRadius:14, border:'1.5px solid #9FBE6A', background:'none', color:'#1C3A1E', cursor:'pointer', fontFamily:'var(--font-body)', fontWeight:600 }}>{q}</button>
              ))}
            </div>
          )}

          {/* Input */}
          <div style={{ padding:'10px 12px', borderTop:'1px solid rgba(159,190,106,0.2)', display:'flex', gap:8 }}>
            <input style={{ flex:1, padding:'10px 14px', borderRadius:10, border:'1.5px solid rgba(159,190,106,0.4)', fontSize:14, background:'#FDFBF7', fontFamily:'var(--font-body)', outline:'none', color:'var(--ink)' }}
              placeholder="Pregunta algo..." value={msgInput}
              onChange={e=>setMsgInput(e.target.value)}
              onKeyDown={e=>e.key==='Enter'&&enviarChat()} />
            <button onClick={enviarChat} disabled={chatLoading}
              style={{ background:'#9FBE6A', color:'#1C3A1E', border:'none', borderRadius:10, padding:'0 16px', fontSize:18, cursor:'pointer', fontWeight:700 }}>↑</button>
          </div>
        </div>
      )}

      {/* FAB — imagen alternada */}
      {!chatOpen && (
        <button onClick={() => setChatOpen(true)}
          style={{ position:'fixed', bottom:24, right:24, width:68, height:68, borderRadius:'50%', background:'transparent', border:'none', cursor:'pointer', zIndex:200, padding:0, boxShadow:'0 6px 24px rgba(28,58,30,0.25)' }}
          title="Asistente Wawita">
          <img src={CHAT_IMGS[chatImg]} alt="Chat Wawita"
            style={{ width:'100%', height:'100%', borderRadius:'50%', objectFit:'cover', transition:'opacity 0.4s' }} />
        </button>
      )}
    </div>
  );
}
